import { GET_FEATURED_OFFERS_FULFILLED } from 'constants/ActionTypes';
const offersFeaturedReducer = (state = null, action) => {
    switch (action.type) {
        case GET_FEATURED_OFFERS_FULFILLED: {
            return action.payload.data.map((model) => model.id.toString());
        }
        default:
            return state;
    }
};
export default offersFeaturedReducer;
